import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Button, ProgressBar, Badge, Image, InputGroup, Form } from 'react-bootstrap';
import { LanguageProvider } from '../core/language-provider';
import { DataManager } from '../core/data-manager';
import { ResourceManager } from '../core/resource-manager';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CardAssociazioni from '../components/Card/Associazioni';
import { ViewManager } from '../core/view-manager';
import { Utils } from '../core/utils';
import { LoginManager } from '../core/login-manager';
import { ApiManager } from '../core/api-manager';




export default function Associations() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);
    const [search, setSearch] = useState("");
    const searchableFields = Utils.cloneObject(ViewManager.getSearchableColumns('association'));
    const userInfo = LoginManager.getUserInfo();

    useEffect(() => {
        getAssociation()
    }, []);

    useEffect(() => {
        const timeOutId = setTimeout(() => getAssociation(), 400);
        return () => clearTimeout(timeOutId);
    }, [search]);


    async function getAssociation() {
        console.log(search)
        let constraints = [];
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('association', 1, 1000, sorting, search, searchableFields, constraints)
        if (response.success === 1) {
            var t = response.body
            for (let i = 0; i < t.length; i++) {
                let c = [
                    {
                        "fieldName": "idAssociation",
                        "type": "value",
                        "value": t[i].id
                    },
                    {
                        "fieldName": "public",
                        "type": "value",
                        "value": 1
                    }
                ];
                var s = {
                    'field': 'id',
                    'order': 'desc'
                }
                //var resCourse = await DataManager.searchItems('course', 1, 1000, s, '', [], c);
                var body = {
                    limit: 1000,
                    query: null,
                    category: null,
                    offset: 0,
                    idAssociation: t[i].id
                }
                var resCourse = await ApiManager.sendAuthenticatedRequest('/custom/get_courses', body);
                var resEvent = await DataManager.searchItems('event', 1, 1000, s, '', [], c);
                if (resCourse.success === 1 && resCourse.body.length > 0) {
                    t[i].courses = resCourse.body.length
                }
                if (resEvent.success === 1 && resEvent.body.length > 0) {
                    t[i].events = resEvent.body.length
                }
            }
            console.warn(t)
            setData(t)
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }




    if (data) {
        return (
            <>
                <Helmet>
                    <title>{LanguageProvider.get('header.associati')}</title>
                </Helmet>

                <Container fluid className='text-white' style={{ backgroundColor: 'var(--secondary-color)', height: '100%' }}>
                    <Container fluid={'md'}>
                        <Row style={{ paddingTop: '75px', paddingBottom: '75px', color: 'var(--primary-color)' }}>
                            <Col>
                                <h2>{LanguageProvider.get('header.associazioni')}</h2>
                                <h6 style={{ maxWidth: 600 }}>Fedespedi è presente su tutto il territorio nazionale attraverso la propria rete di Associazioni Territoriali</h6>
                            </Col>
                        </Row>
                    </Container>

                </Container>


                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }


                <Container fluid>
                    <Container fluid={'md'} className='mb-5'>
                        <Row className='my-5'>
                            <Col style={{ color: 'var(--primary-color)' }}>
                                <h4>Tutte le associazioni</h4>
                                <p className='mt-4'>Le suddette associazioni territoriali:</p>
                                <ul>
                                    <li>garantiscono la rappresentanza del settore della logistica, del trasporto e delle spedizioni a livello provinciale e regionale;</li>
                                    <li>collaborano quotidianamente con la Federazione a iniziative di promozione e approfondimento tecnico;</li>
                                    <li>offrono un’ampia gamma di servizi, come formazione, attività di promozione del settore e orientamento a fini occupazionali e assistenza sindacale.</li>
                                </ul>
                                <p>Il rapporto tra Federazione e Associazioni Territoriali è previsto dallo Statuto Fedespedi (art. 5).</p>

                            </Col>
                        </Row>
                        <Row className='my-5 justify-content-end'>
                            {/* Barra di ricerca */}
                            {/* <Col md={3} className='ps-0'>
                                <InputGroup>
                                    <Form.Control style={{ borderStartStartRadius: '20px', borderBottomLeftRadius: '20px', borderColor: 'var(--primary-color)', borderRight: '0' }}
                                        placeholder="Cerca" onChange={(e) => setSearch(e.target.value)}
                                    />
                                    <InputGroup.Text style={{ borderTopRightRadius: '20px', borderBottomRightRadius: '20px', borderLeft: '0', borderColor: 'var(--primary-color)', backgroundColor: 'white' }}>
                                        <FontAwesomeIcon icon='search'></FontAwesomeIcon></InputGroup.Text>
                                </InputGroup>
                            </Col> */}
                        </Row>
                        {data && data.length > 0 ? (
                            <Row className='mt-5 mb-5 justify-content-between'>
                                {data.map((item, j) => {
                                    return (
                                        <Col md={6} xs={12} key={j}>
                                            <CardAssociazioni data={item}></CardAssociazioni>
                                        </Col>
                                    )
                                })}
                            </Row>
                        ) : (
                            <>
                                <p className='text-muted text-center'>Nessuna associazione trovata.</p>
                            </>
                        )}
                    </Container>

                </Container>

            </>
        )
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};